<template>
  <BaseItem
      ref="BaseItem"
      :item-uid="itemUid"
      parentComponent="TaskTypeTable"
      dto-detail-model="TaskTypeDetailQueryDTO"
      dto-save-model="TaskTypeSaveCommandDTO"
      dto-restore-model="TaskTypeRestoreCommandDTO"
      dto-filter-restore-model="TaskTypeDetailResponseDTO"
      :store-name="store_name"
      :modal-dialog="modalDialog"
      :routeFullScreen="routeFullScreen"
  >
    <template v-slot:body="{editedItem, editedItemCommon, slotHeight, lockPage}">
          <v-col cols="12">
            <v-text-field
                v-model="editedItem.name"
                label="Name"
                outlined
                :counter="50"
                required
                :filled="lockPage"
                :readonly="lockPage"
                :background-color="getBackColor(editedItem)"
            ></v-text-field>
          </v-col>
        <v-row class="ml-0 mr-0">
          <v-col cols="3">
            <v-checkbox v-model="editedItem.need_effort" :label="$t('columns.need_effort')" dense
                        class="mt-0"
                        :filled="lockPage"
                        :readonly="lockPage"
            ></v-checkbox>
            <v-spacer></v-spacer>
            <v-checkbox v-model="editedItem.required" :label="$t('columns.required')" dense class="mt-0"
                        :filled="lockPage"
                        :readonly="lockPage"
            ></v-checkbox>
            <v-spacer></v-spacer>
            <v-checkbox v-model="editedItem.need_photo" :label="$t('columns.need_photo')" dense
                        class="mt-0"
                        :filled="lockPage"
                        :readonly="lockPage"
            ></v-checkbox>
          </v-col>
          <v-col cols="3">
            <v-radio-group v-model="editedItem.group" class="mt-0"
                           :filled="lockPage"
                           :readonly="lockPage"
            >
              <v-radio value="smd" :label="$t('columns.smd')"></v-radio>
              <v-spacer></v-spacer>
              <v-radio value="tht" :label="$t('columns.tht')"></v-radio>
              <v-spacer></v-spacer>
              <v-radio value="pre_smd" :label="$t('columns.pre_smd')"></v-radio>
              <v-spacer></v-spacer>
              <v-radio value="pre_tht" :label="$t('columns.pre_tht')"></v-radio>
              <v-spacer></v-spacer>
              <v-radio value="pre_material_smd" :label="$t('columns.pre_material_smd')"></v-radio>
              <v-spacer></v-spacer>
              <v-radio value="pre_material_tht" :label="$t('columns.pre_material_tht')"></v-radio>
              <v-spacer></v-spacer>
              <v-radio value="generic" :label="$t('columns.generic')"></v-radio>
              <v-spacer></v-spacer>
              <v-radio value="external" :label="$t('columns.external')"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="6">
            <v-textarea v-model="editedItem.description" outlined :label="$t('columns.description')"
                        :filled="lockPage"
                        :readonly="lockPage"
                        rows="4"
            ></v-textarea>
          </v-col>
        </v-row>
      <BaseColorPicker v-model="editedItem.color" :readonly="lockPage"></BaseColorPicker>
    </template>
  </BaseItem>
</template>

<script>
// import {mapGetters, mapActions} from 'vuex';
// import {mapFields} from 'vuex-map-fields';
import ConfirmDialog from "@/components/Base/ConfirmDialog";
import BaseItem from "@/components/Base/BaseItem";
import BaseColorPicker from "@/components/Base/BaseColorPicker";


export default {
  name: 'TaskTypeItem',
  props: {
    subtractHeight: {type: [Number], default: 100},
    height: {type: [Number], default: window.innerHeight},
    itemUid: {default: null},
    store_name: {type: [String], default: 'TaskTypeTable'},
    modalDialog: {type: [Boolean], default: false},
    routeFullScreen: {type: [Object], default: null},
  },

  components: {
    ConfirmDialog,
    BaseItem,
    BaseColorPicker,
  },

  computed: {},

  methods: {
    getBackColor(editedItem) {
      if (!!editedItem.color && typeof editedItem.color === 'string') {
        return editedItem.color
      }
      return 'white'
    }
    ,
  },

  async mounted() {
  }
  ,

  data() {
    return {
      validateDiff: true,
      validate: null,
    }
  }
}
</script>

<style>
.no-spin input[type='number'] {
  -moz-appearance: textfield;
  /*width: 50px;*/
}

</style>

<i18n src=".\locales.json">
</i18n>
